<div>

    <!-- page title -->
    <h1 class="page_title">
        <mat-icon>reviews</mat-icon>
        <span>
            <span>Feedback</span>
            <small>Condividi il tuo feedback sull'incontro.</small>
        </span>
    </h1>

    <!-- page content -->
    <div class="page_content">
        <div class="inner">
            <div class="pwa_form">
                <form [formGroup]="form">
                    <!-- star -->
                    <div class="pwa_form_control">
                        <label>
                            <mat-icon>chevron_right</mat-icon>
                            <span>Come è andato l'incontro ?</span>
                        </label>

                        <div class="star-rating-container star-rating-animation mb-6">
                            @for(star of stars; track star){
                            <div [ngClass]="[star.class]" (click)="selectStar(star.id)">
                                <mat-icon>{{star.icon}}</mat-icon>
                            </div>
                            }
                        </div>
                    </div>

                    <!-- note -->
                    <div class="pwa_form_control">
                        <label>
                            <mat-icon>chevron_right</mat-icon>
                            <span>Vuoi aggiungere delle note?</span>
                        </label>
                        <mat-form-field>
                            <textarea matInput rows="5" maxlength="500" formControlName="note" placeholder="Aggiungi delle note sull'incontro"></textarea>
                        </mat-form-field>
                    </div>

                    <button mat-flat-button color="accent" class="send_button mb-6" (click)="onSubmit()" [disabled]="!form.valid || isSending">Invia feedback</button>
                </form>
            </div>
        </div>
    </div>
</div>
